import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "exam-question-page" }
const _hoisted_2 = {
  key: 0,
  class: "submit-loading-overlay"
}
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex flex-column h-100" }
const _hoisted_5 = { class: "pa-3 d-flex align-center justify-space-between" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"flex":"1","overflow-y":"auto"} }
const _hoisted_8 = { class: "pa-3" }
const _hoisted_9 = { class: "exam-question-content" }
const _hoisted_10 = {
  key: 0,
  class: "pa-4"
}
const _hoisted_11 = {
  key: 1,
  class: "question-main-area"
}
const _hoisted_12 = {
  key: 0,
  class: "d-flex question-layout"
}
const _hoisted_13 = { class: "question-left-panel" }
const _hoisted_14 = {
  key: 0,
  class: "title m-0"
}
const _hoisted_15 = {
  key: 1,
  class: "title m-0"
}
const _hoisted_16 = {
  key: 0,
  class: "title m-0"
}
const _hoisted_17 = {
  key: 1,
  class: "title m-0"
}
const _hoisted_18 = {
  key: 0,
  class: "title m-0 result-success"
}
const _hoisted_19 = {
  key: 1,
  class: "title m-0 result-failed"
}
const _hoisted_20 = {
  key: 2,
  class: "title m-0 result-not-full"
}
const _hoisted_21 = { class: "question-container test-main report-for-exam" }
const _hoisted_22 = { class: "col-lg-12 p-0" }
const _hoisted_23 = { class: "m-0" }
const _hoisted_24 = { class: "col-lg-12 p-0 mt-2 mb-2" }
const _hoisted_25 = { class: "progress-answer" }
const _hoisted_26 = { class: "col-lg-12 p-0" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "col-lg-12 p-0" }
const _hoisted_29 = { class: "m-0" }
const _hoisted_30 = {
  key: 1,
  class: "col-lg-12 p-0"
}
const _hoisted_31 = { class: "m-0" }
const _hoisted_32 = {
  key: 0,
  class: "question-container test-main p-2"
}
const _hoisted_33 = { class: "result-title" }
const _hoisted_34 = {
  key: 1,
  class: "question-container test-main"
}
const _hoisted_35 = {
  key: 0,
  class: "divider"
}
const _hoisted_36 = { class: "d-flex justify-center align-center w-100" }
const _hoisted_37 = { class: "question-right-panel" }
const _hoisted_38 = { class: "title m-0" }
const _hoisted_39 = { class: "question-list-show" }
const _hoisted_40 = { class: "d-flex justify-center align-center w-100" }
const _hoisted_41 = { class: "bg-white mobile-layout" }
const _hoisted_42 = { class: "mobile-timer-bar d-flex align-center py-2 px-2" }
const _hoisted_43 = { class: "flex-grow-1 d-flex justify-center" }
const _hoisted_44 = {
  key: 0,
  class: "mobile-embed-footer"
}

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ProgressQuestion from '../atoms_molecules/ProgressQuestion.vue'
import SlideBar from '../atoms_molecules/SlideBar.vue'
import { checkMobile } from '../../utils/utils'
import ChartProgress from '../atoms_molecules/ChartProgress.vue'
import { ROUTER_NAME } from '../../router'
import { examGoalContext, goalPath } from '../../utils/exam_goal_context'
import { find } from 'lodash'
import AsForm from '../../../api/v2/forms/as'
import Exam from '../../models/exam'
import { differenceInSeconds } from 'date-fns'
import ExamStatusForm from '../../../api/v2/forms/answer_status'
import { LETTER_FORMAT } from '../../utils/constants'
import Question from '../../models/question'
import ExamTestQuestionBodyWeb from '../atoms_molecules/ExamTestQuestionBodyWeb.vue'
import ExamTestQuestionBodyMobile from '../atoms_molecules/ExamTestQuestionBodyMobile.vue'
import QuestionGroupTestList from '../atoms_molecules/QuestionGroupTestList.vue'
import { GroupQuestion } from '../../../api/v2/models/question'
import hotkeys from 'hotkeys-js'
import ExamResultQuestionBodyWeb from '../atoms_molecules/ExamResultQuestionBodyWeb.vue'
import ExamResultQuestionBodyMobile from '../atoms_molecules/ExamResultQuestionBodyMobile.vue'
import ExamTimer from '../atoms_molecules/ExamTimer.vue'
import ButtonReload from '../atoms_molecules/ButtonReload.vue'
import HeaderUser from '../organisms/HeaderUser.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { focusMathliveElement } from '../../../../lib/mathlive'
import { examTestState } from '../../stores/exam_test'
import { RouteLocationNormalized } from 'vue-router'
import { EMBED_ROUTER_NAME } from '../../../embed/router'
import { userState } from '../../stores/user'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTestMain',
  setup(__props) {

class QuestionValueForm {
  public value: string[] = []
  public text: string = ''
  constructor(public readonly question: Question) {}
}

const DefaultFooterMobile = () => ({
  color: '#7DD420',
  show: true,
  default: { show: false },
  buttons: { show: true, items: [] as any[] }
})

const route = useRoute()
const router = useRouter()

const isEmbed = computed(() => !!route.meta?.embed)

const confimDialog = ref(false)
const showQuestionDrawer = ref(false)
const saving = ref(false)
const submitting = ref(false)
// Groups submitted (回答 pressed) this session. Needed so an empty textfield (which creates no
// answer record, so backend treats it as unanswered) is still considered submitted -> button moves to "次へ".
const submittedGroupIds = ref<number[]>([])
const groupQuestion = ref<GroupQuestion>(new GroupQuestion(-1, []))
const isShowBody = ref(true)
const questionValueForms = ref<QuestionValueForm[]>([])
const mobile = ref(checkMobile())
const timer = ref<any>(null)
const time = ref(0)
const timeOut = ref(false)
const questionNumber = ref(0)
const isReport = ref(false)

const schoolSetting = computed(() => headerState.schoolSetting)
const exam = computed(() => examTestState.exam)
const user = computed(() => userState.user)
const redirectNotFoundPage = computed(() => examTestState.redirectNotFoundPage)
const examTestQuestionsAnswered = computed(() => examTestState.examTestQuestionsAnswered)
const groupExamTestQuestions = computed(() => examTestState.groupExamTestQuestions)
const groupQuestions = computed(() => examTestState.groupQuestions)

const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))
const userExam = computed(() => {
  if (!userExamId.value) return exam.value?.userExam
  return exam.value?.userExams.find(item => item.id == parseInt(userExamId.value as string))
})

const headerNavTextColor = computed(() => schoolSetting.value?.navTextColor)
const headerNavColor = computed(() => schoolSetting.value?.navColor || '#1976D2')
const hamburgerColor = computed(() => schoolSetting.value ? `color: ${schoolSetting.value.hamburgerColor}` : 'color: white')

const headerTitle = computed(() => questionNumber.value ? '問題 ' + questionNumber.value : '説明')
const userScore = computed(() => groupQuestion.value.userScore)
const maxScore = computed(() => groupQuestion.value.maxScore)

const groupIndex = computed(() => {
  for (let i = 0; i < groupExamTestQuestions.value.length; i++) {
    if (groupExamTestQuestions.value[i].groupId == groupQuestion.value.groupId) return i
  }
  return -1
})

const isLastItem = computed(() => groupIndex.value === groupExamTestQuestions.value.length - 1)
const isFirstItem = computed(() => groupIndex.value === 0)
const isAnswered = computed(() => {
  const gid = groupQuestion.value?.groupId
  // Group submitted this session (covers empty textfields that create no answer record)
  if (gid != null && submittedGroupIds.value.includes(gid)) return true
  // Or at least one question in the group is answered per backend
  return groupQuestion.value.questions.some((q) => !!examTestQuestionsAnswered.value.find((item) => item.id == q.id))
})
const isFullAnswered = computed(() => groupQuestion.value.questions.every(q => !!examTestQuestionsAnswered.value.find((item) => item.id == q.id)))
const isExamResultAfterQuestion = computed(() => exam.value?.isResultAfterQuestion && isAnswered.value)

const buttonHandler = computed(() => {
  if (isReport.value) return { label: '提出する', action: () => { confimDialog.value = true } }
  if (groupQuestion.value?.isDescriptionQuestion) return { label: '次の質問へ', action: next }
  if (isAnswered.value) {
    if (isLastItem.value && isFullAnswered.value) return { label: 'ステータスを確認する', action: next }
    if (exam.value?.isResultAfterQuestion) return { label: '次の質問へ', action: next }
  }
  return { label: '回答', action: saveAndNext }
})

const getGlobalCss = () => exam.value?.globalCss || ''
const applyGlobalCss = () => {
  const style = document.createElement('style')
  style.textContent = getGlobalCss()
  document.head.appendChild(style)
}

const getQuestionNumber = (groupExamTestQuestion: any) => {
  return groupExamTestQuestions.value
    .filter((item) => item?.questions?.every((q: any) => q && !q.isDescriptionQuestion))
    .indexOf(groupExamTestQuestion) + 1
}

const getRateScore = (score: number, maxScore: number) => maxScore == 0 ? 0 : Math.round((score / maxScore) * 100)

const confimSubmit = () => { confimDialog.value = false; showResult() }

const focusQuestion = (question: Question) => {
  const elm = document.getElementById(`question_${question.id}`)
  if (!elm) return
  if (question.isTextarea) {
    // Focus handling for textarea
  } else {
    const inputElm = elm.getElementsByTagName('INPUT')[0] as HTMLInputElement
    if (inputElm) { focusMathliveElement(inputElm); window.scrollTo(0, 0) }
  }
}

const callBackChange = (value: string[], question: Question) => {
  const questionValueForm = questionValueForms.value.find((item) => item.question.id == question.id)
  if (questionValueForm) { questionValueForm.value = value; questionValueForm.text = value.length ? value[0] : '' }
}

const toExamShow = () => {
  if (user.value?.isGuestExamOnly) { location.href = `/exams/${route.params.examId}`; return }
  router.push({ name: ROUTER_NAME.EXAM_SHOW, params: { examId: route.params.examId as string }, query: route.query })
}

const toExamQuestionList = () => {
  router.push({ name: ROUTER_NAME.EXAM_QUESTION_LIST, params: { examId: route.params.examId as string }, query: route.query })
}

const redirectToNotFoundPage = () => router.push({ name: ROUTER_NAME.NOT_FOUND })
const redirectToExamResult = () => router.push({ name: ROUTER_NAME.EXAM_RESULT, params: { examId: route.params.examId as string }, query: { user_exam_id: userExam.value?.id.toString() } })
// ゴールから開いたテストはゴールへ、テスト一覧から開いたテストはテスト一覧へ
const redirectToExamList = () => {
  const goalContext = examGoalContext(route.params.examId as string)
  router.push(goalContext ? goalPath(goalContext) : { name: ROUTER_NAME.MY_EXAM_LIST })
}

const updateData = (examData: Exam | undefined, routeData: RouteLocationNormalized) => {
  if (!examData || !userExam.value) return
  applyGlobalCss()
  if (examData.isDone(userExam.value) && userExam.value.isWaitingScoreCheck) { redirectToExamList(); return }
  if (userExam.value.finishedAt) { redirectToExamResult(); return }
  if (routeData.name == ROUTER_NAME.QUESTION) {
    const questionIdx = userExam.value.questions.findIndex((item) => item.id.toString() == routeData.params.questionId)
    if (questionIdx == -1) redirectToNotFoundPage()
  }
  questionNumber.value = examData.getQuestionNumberById(parseInt(routeData.params.questionId as string))
  updateMobileBar()
  time.value = examData.timeLimit * 60 - differenceInSeconds(new Date(), userExam.value.startedAt)
  time.value = time.value > 0 ? time.value : 0
  if (time.value <= 0) timeOut.value = true
}

const updateMobileBar = () => {
  if (mobile.value && route.name === ROUTER_NAME.QUESTION && exam.value && userExam.value) {
    const questionIdx = userExam.value.questions.findIndex((item) => item.id.toString() == route.params.questionId)
    const footerMobile = DefaultFooterMobile()
    footerMobile.buttons.items = getFooterItems(userExam.value.questions.length, questionIdx)
    footerState.setFooter(footerMobile as any)
  }
}

const getFooterItems = (count: number, index: number) => [
  { round: false, color: 'white', icon: 'mdi-chevron-double-left', action: first, disabled: index <= 0 },
  { round: false, color: 'white', icon: 'mdi-chevron-left', action: previous, disabled: index <= 0 },
  { round: true, color: 'white', label: buttonHandler.value.label, action: buttonHandler.value.action, disabled: groupQuestion.value?.isDescriptionQuestion && index + 1 >= count },
  { round: false, color: 'white', icon: 'mdi-chevron-right', action: index + 1 >= count ? showFinal : next },
  { round: false, color: 'white', icon: 'mdi-chevron-double-right', action: showFinal }
]

const showResult = async () => {
  if (submitting.value) return // prevent double submit
  submitting.value = true // show loading overlay + block interaction
  try {
    const examStatusForm = new ExamStatusForm()
    examStatusForm.examId = exam.value!.id
    examStatusForm.isFinishExam = true
    examStatusForm.userExamId = userExam.value!.id
    await examTestState.saveExamStatus({ examStatusForm })
    timeOut.value = false
  } finally {
    submitting.value = false
  }
}

const saveAndNext = async () => {
  if (saving.value) return // prevent double-click while saving
  if (groupQuestion.value?.isDescriptionQuestion) { await next(); return }
  // Collect all values BEFORE any API calls to prevent reset issues
  const valuesToSave: { question: Question; value: string[] }[] = []
  for (const qvf of questionValueForms.value) {
    let values = qvf.value
    if (qvf.question?.isTextfield) {
      const questionElm = document.getElementById(`question_${qvf.question.id}`)
      if (questionElm) {
        const textfieldQuestions = questionElm.querySelectorAll('.textfield-question')
        values = []
        for (let i = 0; i < textfieldQuestions.length; i++) {
          values.push((textfieldQuestions[i] as HTMLInputElement).value)
        }
      }
    }
    if (qvf.question?.isInlineSelect) {
      const questionElm = document.getElementById(`question_${qvf.question.id}`)
      if (questionElm) {
        const inlineSelectQuestions = questionElm.querySelectorAll('.inline-select-question')
        values = []
        for (let i = 0; i < inlineSelectQuestions.length; i++) {
          values.push((inlineSelectQuestions[i] as HTMLInputElement).value)
        }
      }
    }
    valuesToSave.push({ question: qvf.question, value: values })
  }
  // Build answer forms for every answerable question in the group
  const forms: AsForm[] = []
  for (const item of valuesToSave) {
    if (!item.question?.isDescriptionQuestion && item.value?.length && time.value > 0) {
      const answerForm = new AsForm()
      answerForm.examId = exam.value!.id
      answerForm.qId = item.question.id.toString()
      answerForm.userExamId = userExam.value!.id
      answerForm.answers = item.value
      forms.push(answerForm)
    }
  }
  if (forms.length) {
    saving.value = true
    try {
      // Save all answers in PARALLEL (independent per question) instead of sequential await.
      const results = await Promise.all(forms.map((form) => examTestState.saveAnswer({ answerForm: form })))
      const latest = results.filter(Boolean).pop()
      if (latest && latest.groupId === groupQuestion.value?.groupId) groupQuestion.value = latest

      // Mark this group as submitted (even with empty textfields) -> button moves to "次へ", result shows
      const gid = groupQuestion.value?.groupId
      if (gid != null && !submittedGroupIds.value.includes(gid)) {
        submittedGroupIds.value = [...submittedGroupIds.value, gid]
      }

      // AI grade (skill scoring) — fire in background, does not block navigation
      const asIds: number[] = groupQuestion.value.questions.flatMap((q) => q.answers.map((a) => a.id))
      forms.forEach((form) => {
        examTestState.saveAiGrade(asIds, form).then((gq) => {
          if (gq && gq.groupId === groupQuestion.value?.groupId) groupQuestion.value = gq
        })
      })
      // Refresh answered-status list once (progress badges) — fire and forget
      examTestState.getExamTestQuestions()
    } finally {
      saving.value = false
    }
  }
  if (exam.value?.isResultAfterSubmit) next()
}

const next = () => {
  if (isLastItem.value) {
    if (mobile.value) showFinal()
    else isReport.value = true
    return
  }
  goQuestion(groupExamTestQuestions.value[groupIndex.value + 1].questions[0].id)
}

const previous = () => {
  if (isFirstItem.value) return
  goQuestion(groupExamTestQuestions.value[isReport.value ? groupIndex.value : groupIndex.value - 1].questions[0].id)
}

const first = () => goQuestion(groupExamTestQuestions.value[0].questions[0].id)

const last = () => {
  if (isLastItem.value && !mobile.value) isReport.value = true
  else goQuestion(groupExamTestQuestions.value[groupExamTestQuestions.value.length - 1].questions[0].id)
}

const goQuestion = (questionId: number | string) => {
  if (isReport.value) isReport.value = false
  const qId = typeof questionId === 'string' ? parseInt(questionId) : questionId
  if (qId != parseInt(route.params.questionId as string)) {
    router.push({ name: ROUTER_NAME.QUESTION, params: { examId: `${exam.value!.id}`, questionId: `${qId}` }, query: route.query })
  }
}

const showFinal = () => router.push({ name: ROUTER_NAME.EXAM_QUESTION_LIST, params: { examId: route.params.examId as string }, query: route.query })

const settupHotKeys = () => {
  removeHotkeys()
  hotkeys.filter = () => true
  hotkeys('ctrl+enter, command+enter', 'exams', () => buttonHandler.value.action())
  hotkeys('ctrl+shift+right, control+shift+right', 'exams', () => next())
  hotkeys('ctrl+shift+left, control+shift+left', 'exams', () => previous())
  hotkeys.setScope('exams')
}

const removeHotkeys = () => hotkeys.deleteScope('exams')

const handleTimeUp = () => {
  if (!timeOut.value) { timeOut.value = true; clearInterval(timer.value) }
}

const reload = () => router.go(router.currentRoute as any)

const changeExam = async (examData: any) => {
  if (!examData) return
  examTestState.setUserExamId(userExam.value!.id)
  await examTestState.getExamTestQuestions()
  examTestState.requestExamGroupQuestion(parseInt(route.params.questionId as string)).then((gq) => {
    groupQuestion.value = gq
    updateData(examData, route)
  })
}

const watchgroupQuestion = () => {
  questionValueForms.value = []
  if (groupQuestion.value) {
    groupQuestion.value.questions.forEach((q) => questionValueForms.value.push(new QuestionValueForm(q)))
  }
  setTimeout(() => {
    if (groupQuestion.value?.questions[0]) focusQuestion(groupQuestion.value.questions[0])
  }, 500)
  updateMobileBar()
}

watch(groupQuestion, watchgroupQuestion)

watch(exam, (examData) => changeExam(examData), { immediate: true })

watch(() => route.fullPath, () => {
  isShowBody.value = false
  isReport.value = false
  setTimeout(() => { isShowBody.value = true; window.scrollTo(0, 0) }, 100)
  examTestState.requestExamGroupQuestion(parseInt(route.params.questionId as string)).then((gq) => {
    groupQuestion.value = gq
  })
  if (document.getElementsByClassName('question-content-show').length) {
    document.getElementsByClassName('question-content-show')[0].scrollTop = 0
  }
  updateData(exam.value, route)
})

watch(redirectNotFoundPage, (val) => {
  if (val) { examTestState.setRedirectNotFoundPage({ status: false }); redirectToNotFoundPage() }
})

onMounted(() => {
  document.documentElement.style.overflow = 'hidden'
  document.body.style.overflow = 'hidden'
  examTestState.requestExamTest(parseInt(route.params.examId as string))
  watchgroupQuestion()
  settupHotKeys()
})

onBeforeUnmount(() => {
  document.documentElement.style.overflow = ''
  document.body.style.overflow = ''
  removeHotkeys()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Submit loading overlay: spinner + block interaction "),
    (submitting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "56",
            width: "5",
            color: "primary"
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Custom Header for Exam Question - ẩn khi embed vào lesson "),
    (exam.value && !isEmbed.value)
      ? (_openBlock(), _createBlock(_component_v_toolbar, {
          key: 1,
          color: headerNavColor.value,
          class: "exam-header",
          flat: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                icon: true,
                variant: "text",
                onClick: toExamShow,
                style: _normalizeStyle(hamburgerColor.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["style"]),
              _createVNode(_component_v_toolbar_title, {
                class: "header-title",
                style: _normalizeStyle({ 'color': headerNavTextColor.value })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(headerTitle.value), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["style"])
            ]),
            _createVNode(_component_v_spacer),
            (mobile.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: true,
                  variant: "text",
                  style: _normalizeStyle(hamburgerColor.value),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showQuestionDrawer.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-menu", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["style"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["color"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Question List Drawer (mobile) "),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: showQuestionDrawer.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showQuestionDrawer).value = $event)),
      location: "right",
      temporary: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (exam.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(examTestQuestionsAnswered.value.length) + "/" + _toDisplayString(exam.value.questionsIgnoreDescription.length) + " 回答済", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_btn, {
              icon: true,
              variant: "text",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showQuestionDrawer.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-close", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_7, [
            (exam.value)
              ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupExamTestQuestions.value, (groupExamTestQuestion, index) => {
                      return (_openBlock(), _createBlock(QuestionGroupTestList, {
                        key: index + 'group',
                        groupExamTestQuestion: groupExamTestQuestion,
                        questionNumber: getQuestionNumber(groupExamTestQuestion),
                        groupQuestions: groupQuestions.value,
                        isExamResultAfterQuestion: exam.value.isResultAfterQuestion,
                        active: !isReport.value && groupExamTestQuestion.groupId == groupQuestion.value?.groupId,
                        padding: true,
                        exam: exam.value,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {goQuestion($event); showQuestionDrawer.value = false})
                      }, null, 8 /* PROPS */, ["groupExamTestQuestion", "questionNumber", "groupQuestions", "isExamResultAfterQuestion", "active", "exam"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_dialog, {
              modelValue: confimDialog.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confimDialog).value = $event)),
              width: "500"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  rounded: "",
                  block: "",
                  class: "action-btn-submit"
                }, props), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline bg-grey-lighten-2" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("本当に提出してよろしいですか？", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "text",
                          onClick: confimSubmit
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createCommentVNode(" Main Content "),
    _createElementVNode("div", _hoisted_9, [
      (exam.value && !userExam.value.startedAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_v_alert, { type: "warning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('question.warning_start_exam', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (exam.value && userExam.value.questions && userExam.value.startedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (!mobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_card, { class: "question-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [
                              (groupQuestion.value?.isDescriptionQuestion)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('question.description', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */))
                                : (exam.value.autoDiagnosisEnabled)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(`${_ctx.$t('question.problem', { format: _unref(LETTER_FORMAT).UPTITLECASE })} ${questionNumber.value}`), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      (isReport.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('question.completion_status', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(`${_ctx.$t('question.problem', { format: _unref(LETTER_FORMAT).UPTITLECASE })} ${questionNumber.value}`), 1 /* TEXT */)),
                                      (groupQuestion.value?.isWorkSheet)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 2,
                                            class: "ms-2",
                                            color: "orange",
                                            "text-color": "white"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('question.work_sheet')) + " ", 1 /* TEXT */),
                                              _createVNode(_component_v_icon, { end: "" }, {
                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                  _createTextVNode("mdi-star", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }))
                                        : _createCommentVNode("v-if", true),
                                      (isExamResultAfterQuestion.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            (userScore.value == maxScore.value)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                                  _createVNode(_component_v_icon, { color: "rgb(4, 4, 241)" }, {
                                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                      _createTextVNode("mdi-circle-outline", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode("正解です (" + _toDisplayString(maxScore.value) + "点) ", 1 /* TEXT */)
                                                ]))
                                              : (userScore.value == 0)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                                    _createVNode(_component_v_icon, { color: "rgb(223, 12, 12)" }, {
                                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                        _createTextVNode("mdi-close", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    }),
                                                    _cache[15] || (_cache[15] = _createTextVNode("不正解です (0点) ", -1 /* CACHED */))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                                    _createVNode(_component_v_icon, { color: "rgb(1, 156, 1)" }, {
                                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                        _createTextVNode("mdi-triangle-outline", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(_toDisplayString(getRateScore(userScore.value, maxScore.value)) + "% 正解です (" + _toDisplayString(userScore.value) + "/" + _toDisplayString(maxScore.value) + "点) ", 1 /* TEXT */)
                                                  ]))
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */)),
                              _createVNode(_component_v_spacer),
                              _createVNode(ExamTimer, {
                                time: time.value,
                                timeLimit: exam.value.timeLimit,
                                "start-time": userExam.value.startedAt.toISOString(),
                                onTimeUp: handleTimeUp
                              }, null, 8 /* PROPS */, ["time", "timeLimit", "start-time"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_divider),
                          (isReport.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('question.response', { format: _unref(LETTER_FORMAT).UPFIRSTCASE })), 1 /* TEXT */)
                                      ]),
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("span", _hoisted_25, _toDisplayString(Math.round((examTestQuestionsAnswered.value.length * 100) / exam.value.questionsIgnoreDescription.length)), 1 /* TEXT */),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('question.progress', { format: _unref(LETTER_FORMAT).UPFIRSTCASE })), 1 /* TEXT */)
                                      ]),
                                      (examTestQuestionsAnswered.value.length != exam.value.questionsIgnoreDescription.length)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_26, [
                                              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('question.not_done', { format: _unref(LETTER_FORMAT).UPFIRSTCASE })), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('question.done', { format: _unref(LETTER_FORMAT).UPFIRSTCASE })), 1 /* TEXT */)
                                            ])
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('question.done', { format: _unref(LETTER_FORMAT).UPFIRSTCASE })), 1 /* TEXT */)
                                          ]))
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _createVNode(_component_v_divider)
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (isExamResultAfterQuestion.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestion.value?.questions || [], (item, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: item.id
                                          }, [
                                            _createVNode(ExamResultQuestionBodyWeb, {
                                              id: `question_${item.id}`,
                                              ref_for: true,
                                              ref: `question_${item.id}`,
                                              groupIndex: groupIndex.value + 1,
                                              currentQuestion: item,
                                              index: index + 1,
                                              isMultipleQuestion: (groupQuestion.value?.questions?.length || 0) > 1,
                                              schoolSetting: schoolSetting.value,
                                              exam: exam.value,
                                              "user-exam": userExam.value
                                            }, null, 8 /* PROPS */, ["id", "groupIndex", "currentQuestion", "index", "isMultipleQuestion", "schoolSetting", "exam", "user-exam"]),
                                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "divider" }, null, -1 /* CACHED */))
                                          ], 64 /* STABLE_FRAGMENT */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : (groupQuestion.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestion.value?.questions || [], (item, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: item.id
                                          }, [
                                            _createVNode(ExamTestQuestionBodyWeb, {
                                              exam: exam.value,
                                              id: `question_${item.id}`,
                                              ref_for: true,
                                              ref: `question_${item.id}`,
                                              currentQuestion: item,
                                              index: index,
                                              time: time.value,
                                              onChangeValue: callBackChange
                                            }, null, 8 /* PROPS */, ["exam", "id", "currentQuestion", "index", "time"]),
                                            (groupQuestion.value?.questions && groupQuestion.value.questions.length > 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                                              : _createCommentVNode("v-if", true)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */)),
                          _createVNode(_component_v_card_text, { class: "answer-footer" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(ChartProgress, {
                                size: 100,
                                series: [exam.value.questionsIgnoreDescription.length > 0 ? (examTestQuestionsAnswered.value.length * 100) / exam.value.questionsIgnoreDescription.length : 0],
                                labelColor: '#2699fb',
                                label: examTestQuestionsAnswered.value.length + '/' + exam.value.questionsIgnoreDescription.length,
                                subLabel: _ctx.$t('question.question', { format: _unref(LETTER_FORMAT).UPTITLECASE }),
                                chartColor: '#2699fb',
                                key: 'chart-' + examTestQuestionsAnswered.value.length
                              }, null, 8 /* PROPS */, ["series", "label", "subLabel"]))
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_card_actions, { class: "footer-card-question p-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  class: "m-1 nav-btn",
                                  onClick: first,
                                  disabled: isFirstItem.value
                                }, {
                                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode(" 最初 ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"]),
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  class: "m-1 nav-btn",
                                  onClick: previous,
                                  disabled: isFirstItem.value
                                }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode(" 前へ ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"]),
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  class: "m-1 action-btn-answer",
                                  loading: saving.value,
                                  disabled: saving.value,
                                  onClick: buttonHandler.value.action,
                                  cytag: "center-click"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(buttonHandler.value.label), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["loading", "disabled", "onClick"]),
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  class: "m-1 nav-btn",
                                  onClick: next,
                                  disabled: isLastItem.value
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode(" 次へ ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"]),
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  class: "m-1 nav-btn",
                                  onClick: last,
                                  disabled: isReport.value
                                }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode(" 最後 ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_v_card, { class: "question-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('question.answer_number', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + " " + _toDisplayString(examTestQuestionsAnswered.value.length + '/' + exam.value.questionsIgnoreDescription.length), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_divider),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_v_list, { class: "question-list-block" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupExamTestQuestions.value, (groupExamTestQuestion, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: index + 'group'
                                  }, [
                                    _createVNode(QuestionGroupTestList, {
                                      groupExamTestQuestion: groupExamTestQuestion,
                                      questionNumber: getQuestionNumber(groupExamTestQuestion),
                                      groupQuestions: groupQuestions.value,
                                      isExamResultAfterQuestion: exam.value.isResultAfterQuestion,
                                      active: !isReport.value && groupExamTestQuestion.groupId == groupQuestion.value?.groupId,
                                      padding: true,
                                      exam: exam.value,
                                      onClick: goQuestion
                                    }, null, 8 /* PROPS */, ["groupExamTestQuestion", "questionNumber", "groupQuestions", "isExamResultAfterQuestion", "active", "exam"]),
                                    (index + 1 < groupExamTestQuestion.questions.length)
                                      ? (_openBlock(), _createBlock(_component_v_divider, {
                                          key: index + 'group_divider'
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_card_actions, { class: "footer-card-report p-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_v_dialog, {
                                  modelValue: confimDialog.value,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confimDialog).value = $event)),
                                  width: "500"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({
                                      rounded: "",
                                      class: "m-1 action-btn-submit"
                                    }, props, { cytag: "submit" }), {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 16 /* FULL_PROPS */)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "headline bg-grey-lighten-2" }, {
                                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                            _createTextVNode(" 本当に提出してよろしいですか？ ", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                              color: "primary",
                                              variant: "text",
                                              onClick: confimSubmit,
                                              cytag: "confirm-submit"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Mobile Layout "),
                    _createElementVNode("div", _hoisted_41, [
                      _createCommentVNode(" Mobile Timer "),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(ExamTimer, {
                            time: time.value,
                            timeLimit: exam.value.timeLimit,
                            "start-time": userExam.value.startedAt.toISOString(),
                            onTimeUp: handleTimeUp
                          }, null, 8 /* PROPS */, ["time", "timeLimit", "start-time"])
                        ]),
                        (isEmbed.value)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              icon: true,
                              variant: "text",
                              size: "small",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (showQuestionDrawer.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-menu", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(['mobile-question-container', { 'with-footer': isEmbed.value }])
                      }, [
                        (isExamResultAfterQuestion.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groupQuestion.value?.questions || [], (item, index) => {
                              return (_openBlock(), _createBlock(ExamResultQuestionBodyMobile, {
                                id: `question_${item.id}`,
                                ref_for: true,
                                ref: `question_${item.id}`,
                                key: item.id,
                                groupIndex: groupIndex.value + 1,
                                currentQuestion: item,
                                index: index + 1,
                                isMultipleQuestion: (groupQuestion.value?.questions?.length || 0) > 1,
                                schoolSetting: schoolSetting.value,
                                exam: exam.value,
                                "user-exam": userExam.value
                              }, null, 8 /* PROPS */, ["id", "groupIndex", "currentQuestion", "index", "isMultipleQuestion", "schoolSetting", "exam", "user-exam"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(groupQuestion.value?.questions || [], (item, index) => {
                              return (_openBlock(), _createBlock(ExamTestQuestionBodyMobile, {
                                exam: exam.value,
                                key: item.id,
                                id: `question_${item.id}`,
                                ref_for: true,
                                ref: `question_${item.id}`,
                                currentQuestion: item,
                                index: index,
                                time: time.value,
                                onChangeValue: callBackChange
                              }, null, 8 /* PROPS */, ["exam", "id", "currentQuestion", "index", "time"]))
                            }), 128 /* KEYED_FRAGMENT */))
                      ], 2 /* CLASS */),
                      _createCommentVNode(" Mobile footer buttons for embed mode (embed app has no Footer component) "),
                      (isEmbed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createVNode(_component_v_btn, {
                              icon: true,
                              rounded: "",
                              class: "m-1 mobile-nav-btn",
                              onClick: first,
                              disabled: isFirstItem.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                    _createTextVNode("mdi-chevron-double-left", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              icon: true,
                              rounded: "",
                              class: "m-1 mobile-nav-btn",
                              onClick: previous,
                              disabled: isFirstItem.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              rounded: "",
                              class: "m-1 mobile-action-btn",
                              loading: saving.value,
                              disabled: saving.value,
                              onClick: buttonHandler.value.action
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(buttonHandler.value.label), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["loading", "disabled", "onClick"]),
                            _createVNode(_component_v_btn, {
                              icon: true,
                              rounded: "",
                              class: "m-1 mobile-nav-btn",
                              onClick: next,
                              disabled: isLastItem.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              icon: true,
                              rounded: "",
                              class: "m-1 mobile-nav-btn",
                              onClick: showFinal
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                    _createTextVNode("mdi-chevron-double-right", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
              _createCommentVNode(" Time Out Dialog "),
              _createVNode(_component_v_dialog, {
                modelValue: timeOut.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((timeOut).value = $event)),
                persistent: "",
                "max-width": "290"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                          _createTextVNode("時間切れになりました", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            color: "green-darken-1",
                            variant: "text",
                            onClick: showResult
                          }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("提出", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]))
          : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})